import type { NominatimResult } from '../../types';

interface SearchResultsProps {
  results: NominatimResult[];
  onSelect: (result: NominatimResult) => void;
}

function getShortName(r: NominatimResult): string {
  return r.address.city || r.address.town || r.address.village || r.name || r.display_name;
}

export function SearchResults({ results, onSelect }: SearchResultsProps) {
  if (results.length === 0) return null;

  return (
    <ul
      style={{
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 1000,
        background: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: '0 0 8px 8px',
        listStyle: 'none',
        margin: 0,
        padding: 0,
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        maxHeight: 280,
        overflowY: 'auto',
      }}
    >
      {results.map((r) => (
        <li
          key={r.place_id}
          onClick={() => onSelect(r)}
          style={{
            padding: '10px 14px',
            cursor: 'pointer',
            borderBottom: '1px solid #f5f5f5',
            fontSize: 14,
          }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLLIElement).style.background = '#f5f5f5')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLLIElement).style.background = '')}
        >
          <div style={{ fontWeight: 500 }}>{getShortName(r)}</div>
          <div style={{ color: '#757575', fontSize: 12, marginTop: 2 }}>
            {r.display_name}
          </div>
        </li>
      ))}
    </ul>
  );
}
